import { LegendPath } from '@elastic/charts'

const ON_LEGEND_ITEM_OVER = 'ON_LEGEND_ITEM_OVER'
const ON_LEGEND_ITEM_OUT = 'ON_LEGEND_ITEM_OUT'

function onLegendItemOverAction(legendPath: LegendPath) {
  return { type: ON_LEGEND_ITEM_OVER, legendPath }
}

function onLegendItemOutAction() {
  return { type: ON_LEGEND_ITEM_OUT }
}

export const onLegendItemOver = (chart: any, key: string) => {
  if (!chart?.chartStore) {
    return
  }

  const legendItems = chart.chartStore
    .getState()
    .internalChartState.getLegendItems(chart.chartStore.getState())
  if (!legendItems?.length) {
    return
  }

  const item = legendItems.find(
    (legendItem: any) => legendItem.seriesIdentifiers[0].specId === key
  )
  if (!item) {
    return
  }

  chart.chartStore.dispatch(onLegendItemOverAction(item.path))
}

export const onLegendItemOut = (chart: any) => {
  if (!chart?.chartStore) {
    return
  }

  chart.chartStore.dispatch(onLegendItemOutAction())
}
